<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Solicitudes de permiso por aprobar
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionAprobar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionAprobar = false"
        @do="aprobar"
        ref="aprobarSolicitud"
      )
        span(slot="title") ¿Desea aprobar la solicitud?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Aprobando...
          template(v-else)
            | Aprobar

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionRechazar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionRechazar = false"
        @do="rechazar"
        ref="confirmarRechazar"
      )
        span(slot="title") ¿Desea rechazar la solicitud?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Rechazando...
          template(v-else)
            | Rechazar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionRechazarMasiva"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionRechazarMasiva = false"
        @do="rechazarMasivo"
        ref="confirmarRechazarMasiva"
      )
        span(slot="title") ¿Desea rechazar masivamente?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Rechazando...
          template(v-else)
            | Rechazar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionAprobarMasiva"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionAprobarMasiva = false"
        @do="aprobarMasivo"
        ref="confirmarAprobarMasiva"
      )
        span(slot="title") ¿Desea aprobar masivamente?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Aprobando...
          template(v-else)
            | Aprobar
    .acciones.display-flex.aic.jcc.mb-10(v-if="isSeleccionMasiva")
      button.button.is-small.margin-right-5(@click="confirmarAprobarMasivo")
        span.icon.is-small
          i.fa.fa-paper-plane-o
        span Aprobar
      button.button.is-small.is-danger(@click="confirmarRechazoMasivo")
        span.icon.is-small
          i.fa.fa-times
        span Rechazar
    .body
      transition-group.contenedor-transition(name="fade-smooth-two", tag="div")
        .mensaje-informacion(key="mensaje_no_solicitudes", v-if="!isLoading && lista.length === 0")
          .message.is-info
            .message-body
              span No hay solicitudes de permisos de su equipo por aprobar
        .is-desktop(key="div-table-solicitud-por-aprobar")
          table.table.is-striped.is-bordered(key="table-solicitud-por-aprobar", v-if="lista.length > 0")
            thead
              th
                input(type="checkbox", name="solicitud", :checked="seleccionadosTodos", @change="check('all')")
              th Empleado
              th Tipo
              th Motivo
              th Acciones
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="o in lista"
                :class="{'row-info': o.esDeDelegacion}"
                :key="o.id + 'id'"
              )
                td.ta-center
                  input(type="checkbox", :id="o.id", :checked="o.seleccionado", @change="check(o)")
                td
                  .flex.aic
                    span.hint--top.margin-right-5(:aria-label="'Solicitud Delegada'",v-if="o.esDeDelegacion")
                      i.fa.fa-exclamation-circle
                    .hint--bottom(:aria-label="'Solicitud: ' + o.id")
                      span.hint--right(:aria-label="'Empleado: ' + o.dniEmpleado") {{ o.nombreEmpleado }}
                td {{ o.descripcionTipo }}
                td
                  template(v-if="o.motivo")
                    span {{ o.motivo }}
                  template(v-else)
                    span Sin motivo
                  br
                  .dias-pedidos
                    strong Dias pedidos
                    div(v-for="i in o.detalle")
                      span.detalle-dias {{ i.desde }}{{ i.desde === i.hasta ? '' : ' - ' + i.hasta }}   {{ i.horaDesde }}-{{ i.horaHasta }}
                //- td {{ o.estadoData.descripcion }}
                td.text-center
                  template(v-if="o.adjunto")
                    a.button.is-small(:href="o.adjunto", target="_blank")
                      span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                      span Ver adjunto
                  template(v-else)
                    span.no-accion Sin adjunto
                  .contenedor-acciones(v-if="o.estado === 2 && !isSeleccionMasiva")
                    button.button.is-small(@click="confirmarAprobar(o)")
                      span.icon.is-small
                        i.fa.fa-paper-plane-o
                      span Aprobar
                    button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                      span.icon.is-small
                        i.fa.fa-times
                      span Rechazar
        .is-mobile(key="div-card-solicitud-por-aprobar")
          .box(
            v-for="(o, index) in lista"
            :class="{'row-info': o.esDeDelegacion}"
            :key="o.id + 'id'"
          )
            .checkbox
              input(type="checkbox", :id="o.id", :checked="o.seleccionado", @change="check(o)")
            .empleado.hint--right(:aria-label="'Solicitud: ' + o.id")
              span.hint--top.margin-right-5(:aria-label="'Solicitud Delegada'",v-if="o.esDeDelegacion")
                i.fa.fa-exclamation-circle
              span.hint--bottom(:aria-label="'Empleado: ' + o.dniEmpleado")
                | {{ o.nombreEmpleado }}
            .descripcion-tipo
              span {{ o.descripcionTipo }}
            .motivo
              span {{ o.motivo }}
            .dias-pedidos
              strong Dias pedidos
              div(v-for="i in o.detalle")
                span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
            .botones
              template(v-if="o.adjunto")
                a.button.is-small(:href="o.adjunto", target="_blank")
                  span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                  span Ver adjunto
              template(v-if="o.estado === 2 && !isSeleccionMasiva")
                button.button.is-small(@click="confirmarAprobar(o)")
                  span.icon.is-small
                    i.fa.fa-paper-plane-o
                  span Aprobar
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
          .acciones.display-flex.aic.jcc.mt-10(v-if="isSeleccionMasiva")
            button.button.is-small.margin-right-5(@click="confirmarAprobarMasivo")
              span.icon.is-small
                i.fa.fa-paper-plane-o
              span Aprobar
            button.button.is-small.is-danger(@click="confirmarRechazoMasivo")
              span.icon.is-small
                i.fa.fa-times
              span Rechazar
      loading(v-if="isLoading")
</template>

<script>
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
export default {
  name: 'lista_solicitud_permisos_por_aprobar_component',
  data () {
    return {
      lista: [],
      seleccionadosTodos: false,
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionAprobarMasiva: false,
      mostrarConfirmacionRechazar: false,
      mostrarConfirmacionRechazarMasiva: false,
      mostrarMensajeDeNoSolicitudes: true,
      isLoading: true,
      isSending: false
    }
  },
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  computed: {
    isSeleccionMasiva () {
      return this.lista.filter(o => o.seleccionado).length > 0
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    check (row) {
      if (row === 'all') {
        this.seleccionadosTodos = !this.seleccionadosTodos
        for (let i = 0; i < this.lista.length; i++) {
          this.$set(this.lista[i], 'seleccionado', this.seleccionadosTodos);
        }
        return
      }
      row.seleccionado = !row.seleccionado
      if (!row.seleccionado) {
        this.seleccionadosTodos = false
      }
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/permisos/jefe/poraprobar', obj, function (data) {
        vm.lista = data.lista
        // esto replica la lista 3 veces
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 200})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 300})));
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    confirmarAprobar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionAprobar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.aprobarSolicitud.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarRechazoMasivo () {
      this.mostrarConfirmacionRechazarMasiva = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazarMasiva.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarAprobarMasivo () {
      this.mostrarConfirmacionAprobarMasiva = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarAprobarMasiva.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    aprobar () {
      var vm = this
      var obj = {
        id: vm.solicitudSeleccionada.id
      }
      apiPost(vm, '/permisos/solicitud/aprobar', obj, function (data) {
        vm.mostrarConfirmacionAprobar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    rechazar () {
      var vm = this

      var obj = {
        id: this.solicitudSeleccionada.id
      }

      apiDelete(vm, '/permisos/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    rechazarMasivo () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        ids: vm.lista.filter(o => o.seleccionado).map(o => o.id)
      }
      apiDelete(vm, '/permisos/empleado/masivo/solicitud', obj, function (data) {
        vm.isLoading = false
        vm.mostrarConfirmacionRechazarMasiva = false
        notify(vm, 'success', 'Éxito', 'Solicitudes rechazadas')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    aprobarMasivo () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        ids: vm.lista.filter(o => o.seleccionado).map(o => o.id)
      }
      apiPost(vm, '/permisos/solicitud/masivo/aprobar', obj, function (data) {
        vm.isLoading = false
        vm.mostrarConfirmacionAprobarMasiva = false
        vm.fetch()
        notify(vm, 'success', 'Éxito', 'Solicitudes aprobadas')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .ta-center
    text-align center
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center



  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .position-relative
    position relative

  .quitar
    margin-left 5px
    cursor pointer
    i
      font-size 15px

  .dias-pedidos
    font-size 12px
    color #9a9a9a

  // .fs-12
  //   font-size 12px

  td
    vertical-align: middle;
    .contenedor-acciones
      padding-top 4px
      display flex
      .button
        flex 1
        margin 0px 5px
  td.text-center
    span.no-accion
      font-size: 12px

  .mensaje-informacion
    margin-bottom 10px


  .contenedor-transition
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
      margin-top: 15px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
    .checkbox
      position: absolute;
      top: 10px;
      left: 12px;
      margin-bottom: 1px;
      input
        transform: scale(1.5);
    .empleado
      position absolute
      top 4px
      right 8px
      // right:  8px
      margin-bottom 1px
      .bold
        font-weight bold
    .codigo
      position absolute
      top 4px
      left 8px
      font-weight: bold;
      color #296fa8

  @media (max-width 660px)
    .is-mobile
      display block

    .is-desktop
      display none
</style>



// WEBPACK FOOTER //
// Component_Permisos_Lista_Solicitudes_Por_Aprobar.vue?bcdb78b4